import { getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCmH45b1KyTzmVv2E_Jkguc80pOjfGU74c',
  authDomain: 'study-pro-c6580.firebaseapp.com',
  projectId: 'study-pro-c6580',
  storageBucket: 'study-pro-c6580.firebasestorage.app',
  messagingSenderId: '56848113978',
  appId: '1:56848113978:web:37a886b18108d7d5057003',
  measurementId: 'G-78GYHXTWE9',
};

const firebaseApp1 = initializeApp(firebaseConfig, 'app1');

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(firebaseApp1);

let firebase_app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const storage = getStorage();
